import React from 'react'

import ErrorBoundary from '../../../../components/FundDetails/Modules/Performance/ErrorBoundary.jsx'

import { getExchangeTradedFundsData2 } from '../InvestmentProductsDataSource.js'

import MutualFunds from '../mutualFunds/MutualFunds.jsx'

import ExchangeTradedFundsPerformanceOptions from './ExchangeTradedFundsPerformanceOptions.jsx'
import MorningstarOptions from '../MorningstarOptions.jsx'

import '../InvestmentProducts.css'

export function ExchangeTradedFunds() {
  return (
    <div>
      <div id="funds">
        <ErrorBoundary
          title="Exchange Traded Funds"
          message="Exchange Traded Fund information is currently unavailable due to a technical issue. Please try again later."
          isConstrained={true}
        >
          <MutualFunds
            getData={getExchangeTradedFundsData2}
            getMetadata={null}
            rootNode="etfs"
            aspects={[
              {
                name: '#performance',
                info: {
                  colSpan1: 2,
                  columns: [
                    {
                      ariaLabel: `ETF Name: activate to sort column descending`,
                      content: <>ETF Name</>,
                    },
                  ],
                },
              },
              {
                name: '#prices-yields',
                info: {
                  colSpan1: 1,
                  columns: [
                    {
                      ariaLabel: `ETF Name: activate to sort column descending`,
                      content: <>ETF Name</>,
                    },
                    {},
                    {
                      ariaLabel: 'Market Price Amount: activate to sort column',
                      content: (
                        <>
                          Market
                          <br />
                          Price $
                        </>
                      ),
                    },
                    {
                      ariaLabel:
                        'Premium/Discount Change Amount: activate to sort column',
                      content: (
                        <>
                          Premium/Discount
                          <br />
                          chg ($)
                        </>
                      ),
                    },
                    {
                      ariaLabel:
                        'Premium/Discount Change Percentage: activate to sort column',
                      content: (
                        <>
                          Premium/Discount
                          <br />
                          chg (%)
                        </>
                      ),
                    },
                  ],
                },
              },
              {
                name: '#morningstar-ratings',
                info: {
                  colSpan1: 1,
                  columns: [
                    {
                      ariaLabel: `ETF Name: activate to sort column descending`,
                      content: <>ETF Name</>,
                    },
                  ],
                },
              },
            ]}
            searchPlaceholder="Find an ETF"
            strategyPlaceholder="Strategy"
            ignoreClass={true}
            classOptions={null}
            performanceOptions={ExchangeTradedFundsPerformanceOptions}
            morningstarOptions={MorningstarOptions}
            isEtf={true}
          />
        </ErrorBoundary>
      </div>
      <div id="ampf-trace-loaded-page"></div>
    </div>
  )
}
